
import React from 'react';
import { BookOpen, BarChart, Brain } from 'lucide-react';

const AnalyticsHeader: React.FC = () => {
  return (
    <div className="text-center mb-8">
      <div className="inline-flex items-center justify-center mb-3">
        <div className="w-12 h-12 rounded-full bg-purple-100 flex items-center justify-center mr-3">
          <BarChart className="w-6 h-6 text-purple-600" />
        </div>
        <h1 className="text-3xl font-bold text-gray-900 sm:text-4xl">
          Performance Analysis
        </h1>
      </div>
      <p className="mt-2 text-lg text-gray-600 max-w-2xl mx-auto">
        Track your progress, identify strengths and weaknesses, and optimize your learning path
      </p>
      <div className="flex items-center justify-center space-x-4 mt-4">
        <div className="flex items-center space-x-1 text-purple-700">
          <BookOpen className="w-4 h-4" />
          <span className="text-sm font-medium">Learn</span>
        </div>
        <div className="w-1.5 h-1.5 rounded-full bg-gray-300"></div>
        <div className="flex items-center space-x-1 text-purple-700">
          <Brain className="w-4 h-4" />
          <span className="text-sm font-medium">Improve</span>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsHeader;
